var scope_0 = require('E:/Coding/Journeys/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/13bf9f23056ba46413ad3e818023226c.js').default;
var scope_1 = require('E:/Coding/Journeys/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf69e6773b21a6ed8e25a86c26210ed0.js').default;
var scope_2 = require('E:/Coding/Journeys/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    